module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Once-Upon-A-Time-In-Venice.167f04b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Once-Upon-A-Time-In-Venice.jpg
// module id = hc+n
// module chunks = 0